import * as Yup from 'yup'

import { localeNames } from '../../../../../date/date-properties'
import { currencies } from '../../../../Tenants/codes'

const validateTimezone = (value?: string): boolean => {
  if (!value) {
    return false
  }

  return localeNames.includes(value!)
}

export const validationSchema = Yup.object().shape({
  customerName: Yup.string().trim().min(2).required(),
  abn: Yup.string().trim().min(2).required(),
  domain: Yup.string().min(2).required(),
  isDemo: Yup.boolean(),
  isTrial: Yup.boolean(),
  timezone: Yup.string().test('invalid-timezone', 'invalid timezone', validateTimezone),
  currency: Yup.mixed().oneOf(currencies),
  backOfficeEmail: Yup.string().email().required(),
  tPlusNDays: Yup.number().min(0),
  basisPointFee: Yup.number().min(0),
  enforceSeparationOfDuties: Yup.boolean(),
  signOffCount: Yup.number().when('enforceSeparationOfDuties', {
    is: true,
    then: Yup.number().required().min(0),
  }),
  segmentCode: Yup.string().required(),
  passwordExpiryMonths: Yup.number().min(1).max(12).required(),
  capitalBasisEnabled: Yup.boolean(),
  longTermComplianceOnly: Yup.boolean(),
})

export const ratesheetOptions = [
  { label: 'Default', value: 'DEFAULT' },
  { label: 'Bespoke', value: 'BESPOKE' },
]

export const segmentCodeOptions = [
  { label: 'Bank', value: 'BANK' },
  { label: 'Fund', value: 'FUND' },
  { label: 'Corp', value: 'CORP' },
  { label: 'Local Gov.', value: 'LOCALGOV' },
  { label: 'Not For Profit', value: 'NOT_FOR_PROFIT' },
  { label: 'University', value: 'UNIVERSITY' },
  { label: 'Government', value: 'GOVERNMENT' },
  { label: 'Family Office', value: 'FAMILY_OFFICE' },
]
